// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-theme-homestead -> apartment-management-consultants-theme-homestead-milburn -> parc-lofts
// Generated: 2026-08-21T22:01:04.644Z
// Counts: 7 design, 40 content, 22 slot group, 0 collection binding, 7 section, 0 style

export const designOverrides = {
  "design._site.color.accent": {
    "cssVariable": "--vibe-color-accent",
    "overrideType": "FIELD_MAPPING",
    "value": null,
    "mappedField": "property_color_3"
  },
  "design._site.color.surface": {
    "cssVariable": "--vibe-color-surface",
    "overrideType": "FIELD_MAPPING",
    "value": null,
    "mappedField": "property_secondary_color"
  },
  "design._site.color.textMuted": {
    "cssVariable": "--vibe-color-text-muted",
    "overrideType": "VALUE",
    "value": "#303030",
    "mappedField": null
  },
  "design._site.font.accent": {
    "cssVariable": "--vibe-font-accent",
    "overrideType": "VALUE",
    "value": "'DM Sans', sans-serif",
    "mappedField": null
  },
  "design._site.font.body": {
    "cssVariable": "--vibe-font-body",
    "overrideType": "VALUE",
    "value": "'DM Sans', sans-serif",
    "mappedField": null
  },
  "design._site.font.heading": {
    "cssVariable": "--vibe-font-heading",
    "overrideType": "VALUE",
    "value": "'DM Sans', sans-serif",
    "mappedField": null
  },
  "design._site.font.mono": {
    "cssVariable": "--vibe-font-mono",
    "overrideType": "VALUE",
    "value": "'DM Sans', sans-serif",
    "mappedField": null
  }
};

export const contentOverrides = {
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Parc Lofts in Tolleson, AZ, your lifestyle is enhanced by nearby gems like the exhilarating Camelback Ranch, vibrant Friendship Park, and the engaging Mattel Adventure Park. With <a href=\"https://www.liveatparclofts.com/floor-plans/\">spacious one, two, and three-bedroom floor plans</a>, enjoy cozy living paired with excitement just around the corner. See what's nearby!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p> <span> <span>At Parc Lofts in Tolleson, AZ, your ideal living space awaits. Choose from spacious one, two, or three-bedroom floor plans featuring sleek quartz countertops, stainless steel appliances, and private balconies. <a href=\"https://www.liveatparclofts.com/amenities/\">Indulge in top-notch amenities</a> like a hot tub, outdoor fire pit, and pet-friendly spaces. Secure your dream home today!</span> </span> </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Embrace Life in Your Ideal Apartment Community Today</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "feeguide.aim_code": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_aim_property_code"
  },
  "floor-plans-hero.overline": {
    "overrideType": "VALUE",
    "customValue": "<p>1 - 3 Bedroom Apartments</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.heading": {
    "overrideType": "VALUE",
    "customValue": "<p>Find Your Perfect Home</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Parc Lofts in Tolleson, AZ, each apartment is a <a href=\"https://www.liveatparclofts.com/floor-plans/\">sanctuary with open floor plans</a>, stainless steel appliances, and private balconies. Enrich your lifestyle with our clubhouse, outdoor fire pit, and pet park. Embrace comfort, convenience, and community — there’s truly something for everyone here!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.overline": {
    "overrideType": "VALUE",
    "customValue": "<p>Experience Lifestyle-Enhancing Features</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Amenities</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p> <span>At Parc Lofts in Tolleson, AZ, stylish living awaits! Choose from one, two, or three-bedroom floor plans designed for comfort and convenience. Enjoy luxe amenities like a hot tub, pet park, and 24-hour fitness center. Your perfect home is just a click away—lease online today!</span> <span> <span></span> </span> </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Apply Now</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Parc Lofts in Tolleson, AZ, your perfect home awaits with a variety of spacious floor plans, from cozy one-bedroom retreats to expansive three-bedroom residences. Every corner is designed for comfort and style. Have questions? Contact our leasing team today to find your ideal living space!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.overline": {
    "overrideType": "VALUE",
    "customValue": "<p>Reach Out to Learn More</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Contact Us</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p> <span> <span>At Parc Lofts in Tolleson, AZ, our versatile floor plans cater to your lifestyle. Whether you seek a cozy one-bedroom retreat or a spacious three-bedroom haven, each layout is designed with modern living in mind. Browse our available apartment homes and find the perfect space to call your own.</span> </span> </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Floor Plans</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p> <span> <span>At Parc Lofts in Tolleson, AZ, our versatile floor plans cater to your lifestyle. Whether you seek a cozy one-bedroom retreat or a spacious three-bedroom haven, each layout is designed with modern living in mind. Browse our available apartment homes and find the perfect space to call your own.</span> </span> </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Parc Lofts in Tolleson, AZ, envision your ideal living space with our <a href=\"https://www.liveatparclofts.com/floor-plans/\">stunning one, two, and three-bedroom floor plans</a>. Indulge in luxury amenities, from a vibrant clubhouse and relaxing hot tub to a pet-friendly park and state-of-the-art fitness center. Picture yourself living here and elevate your lifestyle!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.overline": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore Our Photo Gallery</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Gallery</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>1 - 3 Bedroom Apartments in Tolleson , AZ , Minutes from Phoenix</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Parc Lofts</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.overline": {
    "overrideType": "VALUE",
    "customValue": "<p>Ideally Located in Tolleson , AZ</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Neighborhood</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "parallaxbanner.eyebrow": {
    "overrideType": "VALUE",
    "customValue": "<p>Tour Anytime. From Any Distance.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "parallaxbanner.title": {
    "overrideType": "VALUE",
    "customValue": "<p>We're Here For You</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Dogs and cats allowed (breed and weight restrictions may apply). Maximum of 2 pets per unit. One-time pet fee: $300 per pet. Monthly pet rent: $35 per pet.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.overline": {
    "overrideType": "VALUE",
    "customValue": "<p>Living with Your Pet</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Pet Policy</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p> <span> <span>Dogs and cats allowed (breed and weight restrictions may apply). Maximum of 2 pets per unit. One-time pet fee: $300 per pet. Monthly pet rent: $35 per pet.</span> </span> </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Living with Your Pet</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Parc Lofts in Tolleson, AZ, choose from thoughtfully designed one, two, and three-bedroom floor plans tailored to your lifestyle. Experience the perfect blend of comfort and style—don’t just take our word for it; hear firsthand from our satisfied residents. Schedule a tour today and feel at home!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.overline": {
    "overrideType": "VALUE",
    "customValue": "<p>Take a Tour of Parc Lofts</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Schedule A Tour</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyoucontent.body": {
    "overrideType": "VALUE",
    "customValue": "<p>Thank you for reaching out! At Parc Lofts in Tolleson, AZ, we offer a variety of stylish floor plans, including one, two, and three-bedroom options to fit your lifestyle. A team member will connect with you soon to help you find your perfect home!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Parc Lofts in Tolleson, AZ, experience the perfect blend of comfort and style with our thoughtfully designed one, two, and three-bedroom floor plans. Immerse yourself in our vibrant community—take a virtual tour today and envision your new life in an apartment that feels like home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.overline": {
    "overrideType": "VALUE",
    "customValue": "<p>Take a Virtual Tour of Our Community</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Virtual Tours</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "propertyoverview.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Find Your Home"
      },
      "url": {
        "type": "VALUE",
        "customValue": "/floor-plans"
      }
    }
  },
  "floorplanslist.contact_cta": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Explore The Area"
      },
      "url": {
        "type": "VALUE",
        "customValue": "/neighborhood"
      }
    }
  },
  "floorplanslist.view_all_cta": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/amenities"
      },
      "label": {
        "type": "VALUE",
        "customValue": "View Amenities"
      }
    }
  },
  "footer.managed_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_company_logo"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_company_logo_media.alt_text"
      }
    }
  },
  "header.resident_access_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_resident_portal_url"
      },
      "label": {
        "type": "VALUE",
        "customValue": "Resident Login"
      }
    }
  },
  "header.schedule_tour_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Schedule A Tour"
      }
    }
  },
  "herocallouts.cta1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "View Pricing & Availability"
      },
      "url": {
        "type": "VALUE",
        "customValue": "/floor-plans/"
      }
    }
  },
  "petpolicy.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Explore All Amenities"
      }
    }
  },
  "herocallouts.cta2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Take a Virtual Tour"
      },
      "url": {
        "type": "VALUE",
        "customValue": "/virtual-tour/"
      }
    }
  },
  "herocallouts.cta3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Explore Our Amenities"
      },
      "url": {
        "type": "VALUE",
        "customValue": "/amenities/"
      }
    }
  },
  "herocallouts.cta4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Browse The Gallery"
      },
      "url": {
        "type": "VALUE",
        "customValue": "/gallery/"
      }
    }
  },
  "imagecallouts.tile1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019f7785-1622-73ad-a142-4db88888c43b.webp"
      }
    }
  },
  "imagecallouts.tile2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019f7785-1662-74ae-a6c9-33e7aabc0811.webp"
      }
    }
  },
  "imagecallouts.tile3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019f66a5-d061-70e1-9a2e-748451d74e12.webp"
      }
    }
  },
  "imagecallouts.tile4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019f66a5-c4f5-736f-86d7-a7e4bc8de5b9.webp"
      }
    }
  },
  "parallaxbanner.primary_cta": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Schedule a Visit"
      },
      "url": {
        "type": "VALUE",
        "customValue": "/schedule-a-tour"
      }
    }
  },
  "parallaxbanner.secondary_cta": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Take a Virtual Tour"
      },
      "url": {
        "type": "VALUE",
        "customValue": "/virtual-tour"
      }
    }
  },
  "petpolicy.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019f7785-2247-729e-8ad6-dbd22a6ba24b.webp"
      }
    }
  },
  "socialconnect.image1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019f7785-1a0e-7568-9c11-45707b3be669.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Cozy bedroom with a queen-size bed, plush bedding, and a large window with city views."
      }
    }
  },
  "socialconnect.image2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019f7785-1662-74ae-a6c9-33e7aabc0811.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Billiard table and bar area in the apartment clubhouse lounge."
      }
    }
  },
  "socialconnect.image3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019f7785-1622-73ad-a142-4db88888c43b.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Rooftop lounge area with bar, seating, and string lights overlooking city."
      }
    }
  },
  "socialconnect.image4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019f7785-1c95-708f-a7de-dd31e8c75eb0.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern dining area with plush seating, large tables, and contemporary chandeliers."
      }
    }
  }
};

export const collectionBindingOverrides = {};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "anyonehome-chatbot",
      "blockId": "anyonehome-chatbot",
      "position": 0
    },
    {
      "sectionId": "lea-chatbot",
      "blockId": "lea-chatbot",
      "position": 0
    }
  ]
};

export const styleOverrides = {};
